import AvApi from '@availity/api-axios';
import { getDeveloperHubPublicApiUrl } from '../config';

export interface DemoKeyResponse {
  key: string;
}

class DemoKeyApi extends AvApi {
  constructor() {
    super({
      url: getDeveloperHubPublicApiUrl('keys/demo/generate'),
      api: false,
      withCredentials: false,
      sessionBust: false,
      headers: {},
    });
  }

  generateDemoKey(): Promise<DemoKeyResponse> {
    return this.create({ gateway: 'mcp-server' }).then((res) => res.data);
  }
}

export default new DemoKeyApi();
